import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  getMissingOrderSerialAllocationCount,
  getOrderSerialDeviceSearchRestrictions,
  getOrderSerialSearchValue,
  itemRequiresOrderSerialNoPreallocation,
} from "../../../Utils/Common";

export default function FindSerialNumbers({
  editedOrder,
  getDevices,
  setAutomaticSerNo,
  automaticSerNo,
}) {
  const { t } = useTranslation();
  return (
    <Dialog
      open={automaticSerNo}
      onClose={() => {
        setAutomaticSerNo(false);
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {t("orders.findSerial")}
      </DialogTitle>
      <DialogContent>
        <Typography>{t("orders.bClassNote")}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setAutomaticSerNo(false);
          }}
          color="primary"
          variant="outlined"
          autoFocus
        >
          {t("no")}
        </Button>
        <Button
          onClick={() => {
            (editedOrder.genericDevices || []).forEach((e) => {
              if (!itemRequiresOrderSerialNoPreallocation(e)) {
                return;
              }
              const missingCount = getMissingOrderSerialAllocationCount(
                e,
                editedOrder.Devices,
              );
              if (!missingCount) {
                return;
              }
              getDevices(
                getOrderSerialSearchValue(e),
                getOrderSerialDeviceSearchRestrictions(e, {
                  hideSecondClass: true,
                  hide3Module: true,
                }),
                missingCount,
              );
            });
            setTimeout(() => {
              setAutomaticSerNo(false);
            }, 1000);
          }}
          color="primary"
          variant="contained"
        >
          {t("yes")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
